/*eslint-disable*/
import React from 'react'
import PropTypes from 'prop-types'
import Input from '../components/SearchInput'

const SearchParams = (props) => {
  const {
    vendorInputChange,
    contractInputChange,
    projectInputChange,
    vendorSearch,
    projectSearch,
    contractSearch,
    vendorValue,
    contractValue,
    projectValue,
    run,
    reset,
    LABEL,
    VALUE
    } = props;
  return (
    <div className="parameter-container">
      <div className="row">
        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <Input
            label="Contract"
            onChange={contractInputChange}
            value={contractValue}
            simpleValue={false}
            loadOptions={contractSearch}
            labelKey={LABEL}
            valueKey={VALUE}
          />
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <Input
            label="Vendor"
            onChange={vendorInputChange}
            value={vendorValue}
            simpleValue={false}
            loadOptions={vendorSearch}
            labelKey={LABEL}
            valueKey={VALUE}
          />
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <Input
            label="Project"
            onChange={projectInputChange}
            value={projectValue}
            simpleValue={false}
            loadOptions={projectSearch}
            labelKey={LABEL}
            valueKey={VALUE}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-3 col-md-4 col-sm-4 col-xs-4">
          <div className="btn-group btn-group-sm" role="group">
            <button className="btn btn-default"
                    onClick={run}
            >Run</button>
            <button className="btn btn-warning"
                    onClick={reset}
            >Reset</button>
          </div>
        </div>
      </div>
    </div>
  );
};
SearchParams.propTypes = {
  vendorInputChange: PropTypes.func.isRequired,
  projectInputChange: PropTypes.func.isRequired,
  contractInputChange: PropTypes.func.isRequired,
  vendorSearch: PropTypes.func.isRequired,
  projectSearch: PropTypes.func.isRequired,
  contractSearch: PropTypes.func.isRequired,
  vendorValue: PropTypes.object,
  projectValue: PropTypes.object,
  contractValue: PropTypes.object,
  run: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired
};
SearchParams.defaultProps = {};

export default SearchParams;


// WEBPACK FOOTER //
// ./src/components/SearchParams.jsx